var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpiredBatchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.35867 0 0 3.35685 0 7.5C0 11.6432 3.35867 15 7.5 15C11.6425 15 15 11.6432 15 7.5C15 3.35685 11.6432 0 7.5 0ZM7.5 1.82437C8.62503 1.82437 9.67222 2.15763 10.5552 2.7244L2.7244 10.5552C2.13663 9.64464 1.82412 8.5838 1.82437 7.5C1.82437 4.37059 4.37059 1.82437 7.5 1.82437ZM7.5 13.1756C6.41625 13.1755 5.3555 12.863 4.44478 12.2756L12.275 4.44478C12.8628 5.35536 13.1753 6.4162 13.175 7.5C13.175 10.6294 10.6294 13.1756 7.5 13.1756Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredBatchIcon);
export default __webpack_public_path__ + "static/media/expired-batch-icon.a52638f98bceec6219143231e3d076e4.svg";
export { ForwardRef as ReactComponent };